import { z } from 'zod';
import { IterableDistanceUnit } from '../../types';

export const geoLocationSchema = z.object({
  lon: z.number(),
  lat: z.number(),
});

export const geoDistanceSchema = z.object({
  distance: z.number(),
  unit: z.nativeEnum(IterableDistanceUnit),
});

export const singleGeoLocationSchema = z.object({
  location: geoLocationSchema.optional(),
  distance: geoDistanceSchema.optional(),
});

export const multiGeoLocationSchema = z.object({
  locations: z.array(geoLocationSchema).optional(),
  distance: geoDistanceSchema.optional(),
});
